import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { CONSOLIDATED_DETAILS } from "@frameworks/web/redux/interfaces/Reports/iFamilyTagging";
class ConsolidatedDetailsActions extends OnePlatformCommonActions {
    getConsolidatedDetails(consolidatedDetails, type) {
        this.dispatch({
            type: CONSOLIDATED_DETAILS,
            payload: { consolidatedDetails },
            reducerName: type,
        });
    }
}
export default ConsolidatedDetailsActions;
